import {InterfaceNews} from "../../../interface/press-center/interface.news";
import queryString from 'query-string';
import { currentUrl, numberSystemDecimal, searchParams } from '../../../common/consts';
// import {NewsStore} from "../../../store/news.store";
interface QueryParams {
    categoryId?: number;
    page?: number;
    isFeatured: string | boolean;
}
export class NewsPageService {
    private readonly categoryId: number | null;
    private readonly page: number | null;
    private readonly searchValue: string | null;

    constructor(
        private loader: HTMLElement | null,
    ) {
        const urlParams = new URLSearchParams(window.location.search);

        const categoryIdParam = urlParams.get('categoryId');
        this.categoryId = categoryIdParam ? parseInt(categoryIdParam, numberSystemDecimal) : null;

        const pageParam = urlParams.get('page');
        this.page = pageParam ? parseInt(pageParam, numberSystemDecimal) : null;

        const searchParam = urlParams.get('search');
        this.searchValue = searchParam ?? null;
    }
    async getNews(isFeatured= 'false'): Promise<InterfaceNews | null> {
        return await this.getNewsByFilterAndPage(this.categoryId, this.page, this.searchValue, isFeatured);
    }
    async getNewsByCategoryId(categoryId: number | null): Promise<InterfaceNews | null> {
        return await this.getNewsByFilterAndPage(categoryId, this.page, this.searchValue);
    }
    async getNewsBySearch(searchValue: string | null): Promise<InterfaceNews | null> {
        return await this.getNewsByFilterAndPage(this.categoryId, this.page, searchValue);
    }
    async getNewsByPage(page: number | null): Promise<InterfaceNews | null> {
        return await this.getNewsByFilterAndPage(this.categoryId, page, this.searchValue);
    }
    async getNewsByFilterAndPage(
        categoryId: number | null,
        page: number | null,
        searchValue: string | null,
        isFeatured = 'false'
    ): Promise<InterfaceNews | null> {
        this.loader?.classList.add('active');

        const queryParams:  Record<string, number | string> = {};


        if (categoryId && categoryId !== -1) {
            searchParams.set('categoryId', categoryId.toString())
            searchParams.set('page', '1')
            currentUrl.search = searchParams.toString();
            history.pushState(null, '', currentUrl.toString());
            queryParams.categoryId = categoryId
            queryParams.page = 1;

        }
        if (searchValue) {
            searchParams.set('search', searchValue)
            searchParams.set('page', '1')
            currentUrl.search = searchParams.toString();
            history.pushState(null, '', currentUrl.toString());
            queryParams.search = searchValue;
        }
        if (page) {
            searchParams.set('page', page.toString());
            currentUrl.search = searchParams.toString();
            history.pushState(null, '', currentUrl.toString());
            queryParams.page = page;
        }
        queryParams.isFeatured = isFeatured;
        try {
            const response = await fetch(
                `/api/press-center/news?${queryString.stringify(queryParams)}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': 'true'
                    },
                });
            const data: InterfaceNews = await response.json();
            this.loader?.classList.remove('active');
            return data;

        } catch (error) {
            this.loader?.classList.remove('active');

            return null;
        }
    }
}
